var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"button-ghost",on:{"click":function($event){return _vm.$router.push({name: 'Home'})}}},[_vm._t("default",function(){return [_vm._v("WRÓĆ DO POCZĄTKU")]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }